import { render, staticRenderFns } from "./ModalDevolverSeriado.vue?vue&type=template&id=5bb41315&"
import script from "./ModalDevolverSeriado.vue?vue&type=script&lang=ts&"
export * from "./ModalDevolverSeriado.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports